/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "in_user",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TokenHolderACL__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
TokenHolderACL__factory.bytecode = _bytecode;
TokenHolderACL__factory.abi = _abi;
//# sourceMappingURL=TokenHolderACL__factory.js.map